exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-title[data-v-d8fbc48c] {\n    margin: 0;\n    padding-top: 0.25em;\n}\n", ""]);

// exports
